import { z } from 'zod';
import { PRODUCT_GROUP_TYPE_SCHEMA } from '../product-group/product-group-type.ts';
import { PositionProductSchema } from './position-product.ts';

export const PositionGroupSchema = z.strictObject({
    id: z.string().uuid(),
    index: z.number().nonnegative(),
    name: z.string(),
    templateId: z.string().uuid(),
    type: PRODUCT_GROUP_TYPE_SCHEMA,
    positionId: z.string().uuid(),
    products: z.array(PositionProductSchema),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date().nullable(),
});
